import { ImageDown } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import ToolPage from "./ToolPage";

export default function PDFtoImage() {
  const { t } = useLanguage();
  const tk = t.tools.pdfToImage;


  const config = {
    title: tk.title,
    description: tk.description,
    action: tk.action,
    hint: tk.dropHint,
    hintSub: tk.dropHintSub,
    endpoint: "/pdf/pdf-to-image",
    accept: ".pdf",
    multiple: false,
    resultType: "download",
    resultFileName: tk.result,
    color: "#b45309",
    Icon: ImageDown,
    toolKey: "pdfToImage",
  };

  return <ToolPage config={config} />;
}
